// extracted by mini-css-extract-plugin
export var dividerContainer = "_65-0";
export var line = "_65-1";